import { routerReducer } from '@ngrx/router-store';
import { ActionReducer, ActionReducerMap, createReducer, on } from '@ngrx/store';
import {
  addTagToAppSuccess,
  chooseContract,
  createAppSuccess,
  createQueueItem,
  createTagsSuccess,
  deleteTagFromAppSuccess,
  fetchAppsSuccess,
  fetchContractEndpointsSuccess,
  fetchContractSuccess,
  fetchCustomerSuccess as fetchCustomerInfoSuccess,
  fetchHistorySuccess,
  fetchQueueStatsSuccess,
  fetchTagsSuccess,
  fetchUserInfoSuccess,
  resetState,
  updateAppSuccess,
  updateTagSuccess
} from './app.actions';
import { AppState } from './app.models';

export const initialStateContracts = {
  selectedContract: null,
  contracts: [],
  endpoints: [],
  customerId: null
};

export const initialStateCustomerInfo = {};

export const initialStateUserInfo = {
  id: null,
  username: null,
  attributes: {
    email: null,
    email_verified: null,
    'custom:customerid': null
  }
};

const _contractReducer = createReducer(
  initialStateContracts,
  on(resetState, () => ({ ...initialStateContracts })),
  on(chooseContract, (state, action) =>  ({ ...state, selectedContract: action.payload })),
  on(fetchContractSuccess, (state, action) => {
    const selectedContract = state.selectedContract ? state.selectedContract : action.payload?.contracts[0].clientId
    return { ...state, contracts: [...action.payload.contracts], fetched: true, selectedContract }
  }),

  on(fetchContractEndpointsSuccess, (state, action) => {
    const { baseUrl, clientId } = state.contracts.find(c => c.contractId === state.selectedContract);
    const endpoints = action.payload.map(e => ({ ...e, uri: baseUrl + e.uri.slice(1) + clientId }))
    return {
      ...state,
      endpoints
    }
  }),
);

const _customerInfoReducer = createReducer(
  initialStateCustomerInfo,
  on(resetState, () => ({ ...initialStateCustomerInfo })),
  on(fetchCustomerInfoSuccess, (state, action) => ({ ...action.payload })),
);

const _userInfoReducer = createReducer(
  initialStateUserInfo,
  on(fetchUserInfoSuccess, (state, action) => ({ ...action.payload })),
);

const _appsReducer = createReducer(
  [],
  on(resetState, () => ([])),
  on(fetchAppsSuccess, (state, action) => (action.payload)),
  on(createAppSuccess, (state, action) => [...state, action.payload.app]),
  on(updateAppSuccess, (state, action) =>
    state.map(app => app.id === action.payload.app.id ? action.payload.app : app)
  ),
  on(addTagToAppSuccess, (state, action) =>
    state.map(app => app.id === action.payload.app.id ? action.payload.app : app)
  ),
  on(deleteTagFromAppSuccess, (state, action) =>
    state.map(app => app.id === action.payload.app.id ? action.payload.app : app)
  ),
);

const _tagsReducer = createReducer(
  [],
  on(resetState, () => ([])),
  on(fetchTagsSuccess, (state, action) => (action.payload)),
  on(createTagsSuccess, (state, action) => [...state, action.payload]),
  on(updateTagSuccess, (state, action) =>
    state.map(tag => tag.id === action.payload.id ? action.payload : tag)
  ),
);

const _historyReducer = createReducer(
  [],
  on(resetState, () => ([])),
  on(fetchHistorySuccess, (state, action) => (action.payload)),
);

const _queueReducer = createReducer(
  [
    // {
    //   id: 'ebfe9b4a-b215-4e8a-9360-fef68aa8578e',
    //   totalCount: 2,
    //   successCount: 1,
    //   errorCount: 1,
    //   noFeedbackCount: 0,
    //   readyState: 100
    // }
  ],
  on(resetState, () => ([])),
  on(createQueueItem, (state, action) => ([...state, { time: Date.now(), readyState: 0, ...action.payload }])),
  on(fetchQueueStatsSuccess, (state, action) => {
    const totalCount = action.payload.resp.reduce((prev, curr) => prev + curr.totalCount, 0);
    const successCount = action.payload.resp.reduce((prev, curr) => prev + curr.successCount, 0);
    const errorCount = action.payload.resp.reduce((prev, curr) => prev + curr.errorCount, 0);
    const noFeedbackCount = action.payload.resp.reduce((prev, curr) => prev + curr.noFeedbackCount, 0);
    const readyState = (100 / totalCount) * (successCount + errorCount + noFeedbackCount);

    const sum = {
      totalCount,
      successCount,
      errorCount,
      noFeedbackCount,
      readyState
    };

    return state.map(item => item.id === action.payload.jobid ? {...item, ...sum} : item)
  }),
);

export function contractReducer(state, action) {
  return _contractReducer(state, action);
}
export function customerInfoReducer(state, action) {
  return _customerInfoReducer(state, action);
}
export function userInfoReducer(state, action) {
  return _userInfoReducer(state, action);
}
export function appsReducer(state, action) {
  return _appsReducer(state, action);
}
export function tagsReducer(state, action) {
  return _tagsReducer(state, action);
}
export function historyReducer(state, action) {
  return _historyReducer(state, action);
}

export function queueReducer(state, action) {
  return _queueReducer(state, action);
}

export const reducers: ActionReducerMap<ActionReducer<AppState>> = {
  contract: contractReducer,
  customerInfo: customerInfoReducer,
  userInfo: userInfoReducer,
  apps: appsReducer,
  router: routerReducer,
  tags: tagsReducer,
  history: historyReducer,
  queue: queueReducer
};
